import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { setPageHeaderTextActionCreator } from 'plugins/store/reducers/common.reducer';
import withStyles from '@material-ui/core/styles/withStyles';

// components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import NavPills from 'components/NavPills/NavPills';
import ThresholdsRecipientList from 'views/BillingReport/BillingReportRecipients'
import BillingReportDownload from 'views/BillingReport/BillingReportDownload';
import CardHeader from 'components/Card/CardHeader';
import CardIcon from 'components/Card/CardIcon';
import CardBody from 'components/Card/CardBody';
import { ReactComponent as BillingReportIconOutlined } from 'assets/img/Menu_BillingReport.svg';

import styles from 'assets/jss/material-dashboard-pro-react/views/billingReportStyles';

class BillingReport extends Component {
	viewName = 'Billing Report';

	componentDidMount() {
		this.props.setPageHeaderText(this.viewName);
	}

	componentWillUnmount() {
		this.props.setPageHeaderText('');
	}

	render() {
		const { classes } = this.props;

		return (
			<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary" icon>
							<CardIcon color="primary">
								<BillingReportIconOutlined />
							</CardIcon>
						</CardHeader>
						<CardBody className={classes.wrapper}>
							<NavPills
								color="warning"
								tabs={[
									{
										tabButton: 'Recipients ',
										tabContent: <ThresholdsRecipientList />,
									},
									{
										tabButton: 'Download Report',
										tabContent: <BillingReportDownload />,
									}
								]}
							/>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
		);
	}
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	setPageHeaderText: bindActionCreators(
		setPageHeaderTextActionCreator,
		dispatch,
	),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BillingReport));
